import { render, staticRenderFns } from "./WidgetPlayer.vue?vue&type=template&id=9967f016&lang=pug&"
import script from "./WidgetPlayer.vue?vue&type=script&lang=js&"
export * from "./WidgetPlayer.vue?vue&type=script&lang=js&"
import style0 from "./WidgetPlayer.vue?vue&type=style&index=0&id=9967f016&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cms/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9967f016')) {
      api.createRecord('9967f016', component.options)
    } else {
      api.reload('9967f016', component.options)
    }
    module.hot.accept("./WidgetPlayer.vue?vue&type=template&id=9967f016&lang=pug&", function () {
      api.rerender('9967f016', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WidgetPlayer.vue"
export default component.exports